import React from 'react'

const Manual_reportes_contables_ecommerce = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Reportes contables de ecommerce
        </h2>
        <iframe
          src="https://scribehow.com/embed/Reportes_contables_de_ecommerce__9V-whbVhQT-R2fJ4VFwXZQ?as=scrollable"
          className="scribe-iframe-general-151"
          width="100%"
          height="6100"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_reportes_contables_ecommerce
